import styled from 'styled-components';

export const ProductColorContainer = styled.div`
  padding: 6px 0 6px 12px;
`;

export const ProductColorCover = styled.p`
  padding: 6px 0 10px;
  font-size: 16px;
  font-weight: 500;
  color: #00000060;
  padding-bottom: 14px;
  .head {
    font-weight: 600;
    color: #000000de;
  }
`;

export const ProductColorUl = styled.ul`
  list-style: none;
  margin: 0;
  display: flex;
  cursor: pointer;
  position: relative;

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar {
    width: 0px;
    height: 6px;
    cursor: pointer;
    background-color: #f5f5f5;
    transition: height 0.4s ease;

    @media (max-width: 720px) {
      display: none;
    }
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgb(0 0 0 / 32%);
    background-color: #c1c1c13b;
  }

  @media (max-width: 720px) {
    cursor: default;
    padding-bottom: 10px;

    &::-webkit-scrollbar {
      display: none;
    }
  }
  & li {
    margin-right: ${(props) => (props.notSingleVariant ? '19px' : '8px')};
    text-align: center;
    border: ${(props) => (props.notSingleVariant ? '' : 'solid 0.7px #e5e5e5')};
    img {
      border-radius: ${(props) =>
        props.notSingleVariant ? '' : '4px 4px 0 0'};
    }
    @media (max-width: 720px) {
      margin: ${(props) => (props.showNewDiaperVariantUx ? '0 4px 4px 0' : '')};
    }
  }
  .color-varient {
    border-radius: 6px !important;
    border: 2px solid #ef4e5e !important;
  }
  .not-selected-color {
    border-radius: 6px !important;
    border: 1px solid #e5e7e7 !important;
  }
  & .lowOpacity {
    opacity: 0.4;
  }
`;
export const ProductColorImage = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 6px;
  border: ${(props) =>
    props.active ? '2px solid#ef4e5e' : '1px solid #e5e7e7'};
`;

export const ProductColorText = styled.p`
  font-size: 10px;
  color: ${(props) => (props.active ? '#ef4e5e' : '#000')};
  font-weight: ${(props) => (props.active ? '600' : '500')};
  text-align: center;
  text-transform: uppercase;
  padding-top: 4px;
`;

export const BlackEighty = styled.span`
color: ${(props) => props.tabThemeColor || 'hsl(0deg, 0%, 0%, 87%)'};
font-weight: bold;
 
`;

export const ProductColorPrice = styled.div`
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    color: #212121;
    padding 4px 0;
`;

